import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';
import { getOrder } from 'src/api/index';
import Header from './components/header';
import OrderProduct from './components/order-product';
import OrderExtra from './components/order-extra';

interface Prop {}
interface State {
    orders: any[];
    commodity: any;
    boughtPackage: any;
}

@injectIntl()
export default class OrderConfirm extends Base<Prop, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            orders: [],
            boughtPackage: {},
            commodity: JSON.parse(sessionStorage.getItem('commodity') as string),
        };
    }

    loadOrder = async () => {
        const { match, history, location } = this.props;
        const { orderId } = match?.params ?? ({} as any);
        const { orders } = location?.state ?? ({} as any);
        if (orderId) {
            const { data } = await getOrder(orderId);
            const { commodity } = this.state;
            let boughtPackage = null;
            for (let i = 0, iLen = commodity?.comboArr?.length; i < iLen; i++) {
                const pkg = commodity?.comboArr?.[i];
                if (pkg.name === data.comboName) {
                    boughtPackage = pkg;
                    break;
                }
            }
            this.setState({ orders: [data], boughtPackage });
        } else if (orders?.length > 0) {
            const boughtPackage = orders.map((o: any) => {
                return { name: o.comboName };
            });
            this.setState({ orders: orders, boughtPackage });
        } else {
            history?.goBack();
        }
    };

    backHomeHandler = () => {
        this.props.history?.goBack();
    };

    componentDidMount() {
        this.loadOrder();
    }

    render() {
        const { orders, commodity, boughtPackage } = this.state;
        return (
            <>
                <Header />
                <div className="explain">
                    <h1>
                        <FormattedMessage id="order-success.title" />
                    </h1>
                    <p>
                        <FormattedMessage id="submit-success-tip" />
                        <span style={{ color: 'red' }}>
                            <FormattedMessage id="submit-remember-order-code" />
                        </span>
                    </p>
                </div>
                <OrderProduct orders={orders} commodity={commodity} pkg={boughtPackage} />
                <OrderExtra orders={orders} commodity={commodity} />
                <div className="timetips">
                    <ul>
                        <li>
                            <img src={require('src/assets/images/7day.png')} alt="" />
                            <FormattedMessage id="7-day" />
                        </li>
                        <li>
                            <img src={require('src/assets/images/huodao.png')} alt="" />
                            <FormattedMessage id="cod" />
                        </li>
                    </ul>
                </div>
            </>
        );
    }
}
